<script lang="ts" context="module">
    import { get, writable } from "svelte/store"

    const dialogueOpen = writable<null | {
        lesson: number
        previous: number
        notfData: NotificationDataType
    }>(null)
    export function checkAndOpenPracticeLessonConflict(lesson: number, previous: number, notfData : NotificationDataType) {
        const current = get(dialogueOpen)
        if (current?.previous) previous = current.previous
        if (previous == lesson) {
            dialogueOpen.set(null)
            return
        }
        dialogueOpen.set({
            lesson,
            previous,
            notfData
        })
    }

    // dialogueOpen.set({ lesson: 2, previous: 3 })

    export async function closeDialogue() {
        // We also need to delete
        // updateThisDeviceLesson()

        dialogueOpen.set(null)
    }
</script>

<script lang="ts">
    import type {
        NotificationDataType,
    } from "@utils/practice/notifications-data"
    import ConflictLessonPopupContent from "./ConflictLessonPopupContent.svelte"
    import { currentNativeNotifications } from "@utils/cap-notification-manager/cap-notification-manager"

    let readingDone: boolean | undefined
    let notificationsSetForPrevious: boolean | undefined
    $: if ($dialogueOpen) {
        readingDone = $dialogueOpen.notfData.getItem($dialogueOpen.lesson).readyForReminders
        //TODO verify this logic with new version
        notificationsSetForPrevious = $currentNativeNotifications?.lesson === $dialogueOpen.previous
    } else {
        readingDone = undefined
        notificationsSetForPrevious = undefined
    }
</script>

{#if $dialogueOpen !== null && readingDone !== undefined && notificationsSetForPrevious !== undefined}
    <ConflictLessonPopupContent
        notfData={$dialogueOpen.notfData}
        previous={$dialogueOpen.previous}
        lesson={$dialogueOpen.lesson}
        {readingDone}
        {notificationsSetForPrevious}
    />
{/if}
